module.exports = __webpack_public_path__ + "img/165-b9aa90.png";